// extracted by mini-css-extract-plugin
export default {"wrapper":"Favoritie_wrapper__omysJ","wrapperTiles":"Favoritie_wrapperTiles__rfZQp","loadingwrapper":"Favoritie_loadingwrapper__93RyW"};